import styled from "styled-components"
import fontValues from "../../../assets/values/fontValues/fontValues.json"

export const CardTitle = styled.h1 `

  padding: 0;
  cursor: pointer;
  text-align: center;
  border: none;
  margin: 0;
  font-family: ${fontValues.TEXT_FONT_FAMILY};
  font-size: ${fontValues.TEXT_SIZE};
  color: ${({theme}) => theme.colors.DARK_TEXT};

`